import { render, staticRenderFns } from "./modifyForm.vue?vue&type=template&id=3ec2d628&scoped=true&"
import script from "./modifyForm.vue?vue&type=script&lang=js&"
export * from "./modifyForm.vue?vue&type=script&lang=js&"
import style0 from "./modifyForm.vue?vue&type=style&index=0&id=3ec2d628&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec2d628",
  null
  
)

export default component.exports